import { render, staticRenderFns } from "./DocumentImage.vue?vue&type=template&id=6f105252&scoped=true&"
import script from "./DocumentImage.vue?vue&type=script&lang=js&"
export * from "./DocumentImage.vue?vue&type=script&lang=js&"
import style0 from "./DocumentImage.vue?vue&type=style&index=0&id=6f105252&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f105252",
  null
  
)

export default component.exports